import gql from 'graphql-tag';
import { cartFragment } from './sharedFragments';

export const CART_DELIVERY_ADDRESSES_ADD_MUTATION = gql`
  mutation CartDeliveryAddressesAdd(
    $cartId: ID!
    $addresses: [CartSelectableAddressInput!]!
  ) {
    cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) {
      userErrors {
        __typename
        code
        field
        message
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${cartFragment}
`;
